// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2twIq","content":"styles_content__weFWE","row":"styles_row__27Sj8","footer":"styles_footer__emixL","phraseLength":"styles_phraseLength__24ZVy"};